import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const OurApproachSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const approaches = [
    {
      title: 'Market Knowledge',
      description: 'Deep understanding of supplier landscapes and regional manufacturing capabilities.',
      image: 'https://public.readdy.ai/ai/img_res/f652a2153b859ef51a8327358cd5420e.jpg',
      icon: 'ri-global-line',
    },
    {
      title: 'Structured Vetting',
      description: 'Rigorous supplier evaluation to ensure reliability, quality, and production readiness.',
      image: 'https://readdy.ai/api/search-image?query=clean%20modern%20illustration%20of%20quality%20inspection%20checklist%20with%20verification%20marks%20and%20evaluation%20criteria%20minimalist%20design%20featuring%20clipboard%20magnifying%20glass%20and%20approval%20stamps%20soft%20gold%20and%20navy%20color%20scheme%20professional%20business%20aesthetic%20representing%20supplier%20vetting%20process&width=600&height=400&seq=approach2&orientation=landscape',
      icon: 'ri-shield-check-line',
    },
    {
      title: 'Data-Informed Workflows',
      description: 'Technology-driven sourcing processes that improve procurement decisions and price visibility.',
      image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20illustration%20of%20data%20analytics%20dashboard%20with%20charts%20graphs%20and%20workflow%20automation%20clean%20interface%20design%20showing%20procurement%20metrics%20and%20price%20comparison%20tools%20soft%20gold%20accents%20on%20white%20background%20professional%20technology%20aesthetic%20representing%20digital%20sourcing%20platform&width=600&height=400&seq=approach3&orientation=landscape',
      icon: 'ri-line-chart-line',
    },
  ];

  return (
    <section ref={ref} className="py-20 sm:py-28 bg-gray-50 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-primary mb-4">
            Our Approach
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {approaches.map((approach, index) => (
            <motion.div
              key={approach.title}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 + index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow group cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={approach.image}
                  alt={approach.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-primary/80 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute bottom-6 left-6 w-14 h-14 bg-gold-accent rounded-xl flex items-center justify-center">
                  <i className={`${approach.icon} text-2xl text-navy-primary`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-navy-primary mb-4">
                  {approach.title}
                </h3>
                <p className="text-base text-gray-700 leading-relaxed">
                  {approach.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurApproachSection;
